module.exports = __webpack_public_path__ + "static/media/washington-nationals-logo.392b54a0.png";